import {AnalysisSelectionItem} from "@/api/Orders/NewCalculatePrice/CalculateSelections/CalculateSelectionsApiSlice";
import {OrderFormFieldAlias, OrderFormFieldRuleInterface} from "@/api/ReferenceBooks/Rules/AnalysisOrderForm/OrderFormFields";

export function getTestTypeAlias(
    testType: string | number,
    analyses: AnalysisSelectionItem[] = [],
) {
    const selected = analyses.find(item => String(item.analyse.id) === String(testType));
    return selected?.analyse.alias ?? "";
}

export function isFieldEnabledByRule(
    fieldAlias: OrderFormFieldAlias,
    rules: OrderFormFieldRuleInterface[] = [],
) {
    return rules.some(r => r.field_alias === fieldAlias && r.is_active);
}
